import { getDefaultClient } from '../../../client/defaultClient';
import { getWalletAccounts } from '../../wallets/getWalletAccounts';

/**
 * Checks if the user is currently signed in to the Dynamic client.
 *
 * The client is considered to be in a signed in state if a user has
 * authenticated or if the client has at least one wallet connected.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns True if the user is signed in, false otherwise.
 */
export const isSignedIn = (client = getDefaultClient()) =>
  Boolean(client.user || getWalletAccounts(client).length > 0);
